import { focusByClass } from './focusByClass';

export const focusTopSelect = (focusField = true) => focusByClass('nav_top_select', focusField);
